module.exports = __webpack_public_path__ + "fonts/Roboto-Regular-webfont.7f1320f7.ttf";